// Use $ instead of $ without replacing global $
(function ($) {
  $(window).on("resize", function () {
    $(".resource-slider-outer").slick("setPosition");
  });
  $(window).on("load", function () {
    // For each .shuffle-slider section, check its own slide count and set class
    $(".shuffle-slider").each(function () {
      var $section = $(this);
      var length = $section.find(".resource-slider-outer .slide-item").length;
      if (length === 3) {
        $section.addClass("slick-item-three");
      } else {
        $section.removeClass("slick-item-three");
      }
    });
    if ($(".shuffle-slider").length > 0) {
      setTimeout(function () {
        $(".resource-slider-outer").css({ opacity: "1" });
        $(".fellow-slider-nav").css({ opacity: "1" });
      }, 500);

      setTimeout(function () {
        $(
          ".shuffle-slider .resource-slider-outer .slick-list .slick-track .slick-current"
        ).addClass("works");
      }, 1000);

      var fellow_slider = $(".resource-slider-outer");
      var fellow_slider_nav = $(".fellow-slider-nav");
      $("#fellows .slide-item").unwrap().unwrap().unwrap();
      fellow_slider
        .on("init", function (event, slick, currentSlide) {
          var cur = $(slick.$slides[slick.currentSlide]),
            next = cur.next(),
            next2 = cur.next().next(),
            prev = cur.prev(),
            prev2 = cur.prev().prev();
          prev.addClass("slick-sprev");
          next.addClass("slick-snext");
          prev2.addClass("slick-sprev2");
          next2.addClass("slick-snext2");
          cur
            .removeClass("slick-snext")
            .removeClass("slick-sprev")
            .removeClass("slick-snext2")
            .removeClass("slick-sprev2");
          slick.$prev = prev;
          slick.$next = next;
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          var cur = $(slick.$slides[nextSlide]);
          slick.$prev.removeClass("slick-sprev");
          slick.$next.removeClass("slick-snext");
          slick.$prev.prev().removeClass("slick-sprev2");
          slick.$next.next().removeClass("slick-snext2");
          (next = cur.next()), (prev = cur.prev());
          //prev2.prev().prev();
          //next2.next().next();
          prev.addClass("slick-sprev");
          next.addClass("slick-snext");
          prev.prev().addClass("slick-sprev2");
          next.next().addClass("slick-snext2");
          slick.$prev = prev;
          slick.$next = next;
          cur
            .removeClass("slick-next")
            .removeClass("slick-sprev")
            .removeClass("slick-next2")
            .removeClass("slick-sprev2");
        });

      //   setTimeout(function () {
      fellow_slider.slick({
        speed: 1000,
        arrows: false,
        dots: true,
        focusOnSelect: true,
        // prevArrow: '<button class="prev"><img src="/themes/hoover/templates/dist/images/resource-slider/arrow_white_prev.svg" alt="prev"><span>prev</span></button>',
        // nextArrow: '<button class="next"><img src="/themes/hoover/templates/dist/images/resource-slider/arrow_white_next.svg" alt="next"><span>next</span></button>',
        infinite: true,
        centerMode: true,
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "0",
        swipe: true,
        // asNavFor: '.fellow-slider-nav',
        // customPaging: function(slider, i) {
        //         return '';
        //     }
        /*infinite: false,*/
        responsive: [
          {
            breakpoint: 1025, // tablet
            settings: {
              slidesPerRow: 1,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767, // mobile landscape
            settings: {
              slidesPerRow: 1,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
      // fellow_slider_nav.slick({
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     arrows: false,
      //     fade: true,
      //     asNavFor: '.resource-slider-outer'
      // });

      $(".resource-slider-outer").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          setTimeout(function () {
            $(".slick-slide").removeClass("works");
            $(".slick-current").addClass("works");
          }, 600);
        }
      );
      $(".resource-slider-outer").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          setTimeout(function () {
            $(".slick-slide").removeClass("works");
            $(".slick-current").addClass("works");
          }, 600);
        }
      );

      // Prevent interactions on adjacent (non-current) slides
      // $('.resource-slider-outer').on(
      // 	'click mousedown touchstart',
      // 	'.slick-snext, .slick-snext2, .slick-sprev, .slick-sprev2, .slick-snext * , .slick-snext2 * , .slick-sprev * , .slick-sprev2 *',
      // 	function(e) {
      // 		e.preventDefault();
      // 		e.stopPropagation();
      // 		e.stopImmediatePropagation();
      // 		return false;
      // 	}
      // );

      $(".shuffle-slider .slick-arrow").click(function () {
        var cureent_slide = $(
          ".shuffle-slider .resource-slider-outer .slick-list .slick-track .slick-current"
        );
      });
    }

    $(".shuffle-slider .auther-wrap a").append(
      "<span  class='text-hide'>Visit</span>"
    );
  });
})(jQuery);
